/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import {
	BackgroundContainer,
	Quote,
	ResponsiveContainer,
	SectionContainer,
	SectionHeading,
} from "@components/elements";
import { QuoteSectionFragment } from "@cosmos/hygraph-schema";
import { cx } from "@panda/css";
import { VStack } from "@panda/jsx";

export const QuoteSection = ({ config, quotes }: QuoteSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(quotes?.length);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
		>
			<ResponsiveContainer>
				<SectionContainer disablePaddingBlockEnd={!!config?.disablePaddingBottom}>
					<VStack
						alignItems="stretch"
						gap={{ md: "eds.dimension.96", mdDown: "eds.dimension.80" }}
						className={cx("quote-section")}
					>
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? quotes?.map((quote, i) => <Quote key={`quote-${i}`} {...quote} />) : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
